import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './PageHeader.css';

class PageHeader extends Component {
  render() {
    const { to, text, icon = 'arrow-left' } = this.props;

    return (
      <div className="page-header">
        { !!to && (
            <Link to={ to }>
              <FontAwesomeIcon icon={ ['fas', icon] } />
              { ' ' } { text }
            </Link>
          )
        }

        { !to && text }
      </div>
    )
  }
}

export default PageHeader;